/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Filter_LabelInputs */

const en_gc_resources_filter_label = /** @type {(inputs: Gc_Resources_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter learning guides`)
};

const zh_gc_resources_filter_label = /** @type {(inputs: Gc_Resources_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选学习指南`)
};

/**
* | output |
* | --- |
* | "Filter learning guides" |
*
* @param {Gc_Resources_Filter_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_filter_label = /** @type {((inputs?: Gc_Resources_Filter_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Filter_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_filter_label(inputs)
	return zh_gc_resources_filter_label(inputs)
});
export { gc_resources_filter_label as "gc.resources.filter.label" }